import Vue from 'vue'
import axiosRestService from '@gms/network/src/axiosRestService';
import { INCLUDES_FOR_RESERVATION_CARD } from '@gms/api/src/api/jsonapi/PredefinedIncludes';
import parseJsonApiResponse from '@gms/api/src/api/jsonapi/ResponseParser';

const initialState = () => ({
  myReservations: [],
  singleReservation: {},
  isLoading: false,
  hasValidToken: false,
  hasError: false,
  errorMessage: null,
})

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: initialState(),
  // -----------------------------------------------------------------
  getters: {
    myReservations: (state) => state.myReservations,
    reservationsCount: (state, getters) => getters.myReservations.length,
    singleReservation: (state) => state.singleReservation,
    isLoading: (state) => state.isLoading,
    hasValidToken: (state) => state.hasValidToken,
    hasError: (state) => state.hasError,
    errorMessage: (state) => state.errorMessage,
    allReservations: (state) => [
      ...state.myReservations,
      ...state.singleReservation,
    ],
    getReservationByToken: (state) => (reservationToken) => state.allReservations.find(
      (reservation) => reservation.token === reservationToken,
    ),
  },
  // -----------------------------------------------------------------
  mutations: {
    setMyReservations: (state, myReservations) => Vue.set(state, 'myReservations', myReservations),
    setSingleReservation: (state, singleReservation) => Vue.set(state, 'singleReservation', singleReservation),
    setIsLoading: (state, isLoading) => Vue.set(state, 'isLoading', isLoading),
    setHasValidToken: (state, hasValidToken) => Vue.set(state, 'hasValidToken', hasValidToken),
    setHasError: (state, hasError) => Vue.set(state, 'hasError', hasError),
    setErrorMessage: (state, { errorMessage, errorCode }) => Vue.set(state, 'errorMessage', { errorMessage, errorCode }),
    reset(state) {
      const newState = initialState()
      Object.keys(newState).forEach((key) => {
        state[key] = newState[key]
      })
    },
  },
  // -----------------------------------------------------------------
  actions: {
    fetchReservations: (context) => axiosRestService
      .get('/reservations/personal_index')
      .then((response) => {
        context.commit('setMyReservations', response.data)
        return Promise.resolve(context.state.myReservations)
      }),
    fetchAllowedSingleReservation: (context, token) => {
      context.commit('setIsLoading', true)
      return axiosRestService
        .get(`/reservation-summaries/${token}`, {
          headers: { Accept: 'application/vnd.api+json' },
          params: {
            include: INCLUDES_FOR_RESERVATION_CARD.join(','),
          },
        })
        .then(async (response) => {
          const parsedBody = await parseJsonApiResponse(response);

          context.commit('setErrorMessage', false)
          context.commit('setSingleReservation', parsedBody)
          context.commit('setHasValidToken', true)
          context.commit('setHasError', false)
          context.commit('setErrorMessage', false)
        })
        .catch((error) => {
          context.commit('setHasError', true)
          context.commit('setHasValidToken', false)
          context.commit('setSingleReservation', null)
          context.commit('setErrorMessage', {
            errorCode: error.response.status,
            errorMessage: error.response.data.errors[0].detail,
            errorDetailCode: error.response.data.errors[0].code,
          })

          if (error.response.status) {
            context.commit('setHasValidToken', false)
          }
        })
        .finally(() => {
          context.commit('setIsLoading', false)
        })
    },
  },
}
